import NullGeneric from "../../../components/NullGeneric/NullGeneric";
import React from "react";

type Props = {
  description: string;
};

const HealthRecordsError = (props: Props) => {
  const { description } = props;

  return (
    <div className="h-full flex flex-col justify-center items-center max-h-[31.25rem]">
      <NullGeneric
        image="/assets/icons/pastVisitNull.png"
        title="We couldn’t load these records"
        description={description}
        showButton={false}
        contentClassName="max-w-[25rem]"
      />
    </div>
  );
};

export default HealthRecordsError;
